import type { GeoPoint } from '../geolocation';
import { OPTIMIZATION_OBJECTIVE } from '../servicebus/optimization';
import {
  QUEUE_OPTIMIZATION_ARRIVAL_STATUS,
  QUEUE_OPTIMIZATION_STATUS,
  type QueueOptimization,
  type QueueOptimizationJob,
  type QueueOptimizationStop,
} from '../queue-optimization/queue-optimization.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class QueueOptimizationJobFactory extends ObjectFactory<QueueOptimizationJob> {
  protected getDefaults(): QueueOptimizationJob {
    return {
      estimatedArrivalTime: undefined,
      estimatedDepartureTime: undefined,
      jobId: 'eeff001122334455aabbccdd',
      sequence: 0,
      taskId: 'ff001122334455aabbccddee',
    };
  }
}

export const queueOptimizationJobFactory = new QueueOptimizationJobFactory();

export class QueueOptimizationStopFactory extends ObjectFactory<QueueOptimizationStop> {
  protected getDefaults(): QueueOptimizationStop {
    return {
      arrivalStatus: QUEUE_OPTIMIZATION_ARRIVAL_STATUS.ON_TIME,
      estimatedArrivalTime: undefined,
      fullAddress: '1 Rue de Paris',
      jobs: [queueOptimizationJobFactory.build()],
      routePolyline: undefined,
    };
  }
}

export const queueOptimizationStopFactory = new QueueOptimizationStopFactory();

export class QueueOptimizationFactory extends ObjectFactory<QueueOptimization> {
  protected getDefaults(): QueueOptimization {
    return {
      ...baseDocumentFactory.build(),
      driverId: 'aabbccddeeff001122334455',
      expiresAt: new Date('2026-01-01T00:30:00.000Z'),
      objective: OPTIMIZATION_OBJECTIVE.TIME,
      requestedAt: new Date('2026-01-01T00:00:00.000Z'),
      skippedJobIds: [],
      snapshotHash: 'a'.repeat(64),
      startPosition: { latitude: 48.8566, longitude: 2.3522 } satisfies GeoPoint,
      status: QUEUE_OPTIMIZATION_STATUS.PENDING,
      stopsQueueId: 'bbccddeeff001122334455aa',
    };
  }
}

export const queueOptimizationFactory = new QueueOptimizationFactory();
